import { drag } from "d3-drag";
import { select } from "d3-selection";
import { zoom } from "d3-zoom";
import { dragended, dragged, dragstarted, dragsubject } from "./events";

export const addZoom = (svg: any, zoomDepth: any) => {
  const _zoom = zoom();

  if (zoomDepth) {
    const svgHeight = svg._groups[0][0].clientHeight;
    const svgWidth = svg._groups[0][0].clientWidth;

    const zoomed = (event: any) => {
      svg.selectAll("._graphZoom").attr("transform", event.transform);
    };

    svg.call(
      _zoom
        .extent([
          [0, 0],
          [svgWidth, svgHeight],
        ])
        .scaleExtent([1, zoomDepth])
        .on("zoom", zoomed)
    );
    svg.call(zoom).on("wheel.zoom", null);
  }

  return _zoom;
};

export function addHoverOpacity(node: any, link: any, hoverOpacity: number) {
  node
    .on("mouseover", function (this: any, d: any) {
      node.style("opacity", hoverOpacity);
      select(this).style("opacity", "1");
      link.style("opacity", (link_d: any) =>
        link_d.source.id === d.id || link_d.target.id === d.id
          ? "1"
          : hoverOpacity
      );
    })
    .on("mouseout", function (d: any) {
      node.style("opacity", "1");
      link.style("opacity", "1");
    });
  return { node, link };
}
export const addDrag = (
  node: any,
  simulation: any,
  enableDrag: any,
  pullIn: any
) => {
  if (enableDrag) {
    node.call(
      drag()
        .subject((event: any) => dragsubject(simulation, event))
        .on("start", (event: any) => dragstarted(simulation, event))
        .on("drag", dragged)
        .on(
          "end",
          pullIn ? (event: any) => dragended(simulation, event) : () => {}
        )
    );
  } else {
    node.call(
      drag()
        .subject((event: any) => dragsubject(simulation, event))
        .on("start", null)
        .on("drag", null)
        .on("end", null)
    );
  }
  return node;
};
